// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"6215b88b","410":"badcec44","440":"e276d1c8","455":"0cfe34f7","488":"dc27bfb4","503":"2142d519","593":"3f17ab01","612":"f4dda574","733":"5d6f0dfd","804":"c7027b8d","860":"41f94d6c","883":"937975d1","953":"191bf7b8","977":"681275da"}[chunkId] + ".chunk.js";
};